module.exports = __webpack_public_path__ + "img/music-note.68c7eaa1.png";